/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/layout'

const agentManageRouter = {
  path: '/manageAgentManage',
  component: Layout,
  hidden: false,
  redirect: 'noredirect',
  name: 'ManageAgentManage',
  meta: {
    title: '代理管理',
    icon: 'agent',
    roles: ['admin']
  },
  children: [
    {
      path: 'agentList',
      component: resolve => require(['@/views/manage/agentManage/agentList'], resolve),
      name: 'AgentList',
      meta: { title: '代理列表', noCache: false }
    },
    // {
    //   path: 'agentGroupList-327',
    //   component: resolve => require(['@/views/manage/agentManage/agentGroupList'], resolve),
    //   name: 'AgentGroupList',
    //   meta: { title: '代理组列表', noCache: false, noKeepAlive: true }
    // },
    {
      path: 'agentAddUpdate/:par',
      component: resolve => require(['@/views/manage/agentManage/agentAddUpdate'], resolve),
      hidden: true,
      name: 'AgentAddUpdate',
      meta: { title: '代理组详情', noCache: false }
    },
    {
      path: 'agentProfitReport',
      component: resolve => require(['@/views/manage/agentManage/agentProfitReport'], resolve),
      name: 'AgentProfitReport',
      meta: { title: '代理提现审批', noCache: false }
    },
    {
      path: 'agentAdjustLog',
      component: resolve => require(['@/views/manage/agentManage/agentAdjustLog'], resolve),
      name: 'AgentAdjustLog',
      meta: { title: '代理调额日志', noCache: false }
    }
  ]
}

export default agentManageRouter



// WEBPACK FOOTER //
// ./src/router/manage/agentManage.js